import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ナビゲーションバー */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img src="https://public.readdy.ai/ai/img_res/546c4600-ce10-4d17-b6d3-fc3d86f18f90.png" alt="ロゴ" className="h-10" />
          <div className="flex items-center gap-8">
            <a href="#author" className="text-white/90 hover:text-white text-sm transition-colors whitespace-nowrap cursor-pointer">著者について</a>
            <a href="#purchase" className="bg-teal-400 text-slate-900 px-6 py-2 rounded-full font-bold text-sm hover:bg-teal-300 transition-all whitespace-nowrap cursor-pointer">購入する</a>
          </div>
        </div>
      </nav>

      {/* ① ファーストビュー */}
      <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/c364a970b700cea2938cfd8db0e3bcef.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15
        }}></div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-3">
              <h1 className="text-4xl sm:text-5xl lg:text-7xl xl:text-8xl font-black text-white leading-tight mb-8 tracking-tight">
                <span className="block mb-2">無職。</span>
                <span className="block mb-2">バツイチ。</span>
                <span className="block mb-2">精神疾患持ち。</span>
                <span className="block text-teal-400 mt-4 sm:mt-6 text-3xl sm:text-4xl lg:text-6xl xl:text-7xl leading-snug">それでも、医者彼氏ができた。</span>
              </h1>
            </div>
          </div>
          
          <div className="flex justify-center mt-10 sm:mt-16">
            <a href="#purchase" className="group bg-teal-400 text-slate-900 px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-xl font-bold hover:bg-teal-300 transition-all shadow-2xl hover:shadow-teal-400/50 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer">
              今すぐ読む
              <i className="ri-arrow-right-line text-xl sm:text-2xl group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </section>

      {/* ② 共感ゾーン */}
      <section className="py-16 sm:py-32 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-white rounded-[40px] sm:rounded-[60px] shadow-2xl p-8 sm:p-16">
            <div className="mb-10 sm:mb-16">
              <p className="text-slate-500 text-base sm:text-xl mb-6 sm:mb-8">こう思ってない？</p>
              <div className="space-y-4 sm:space-y-6">
                <div className="bg-rose-50 rounded-3xl p-4 sm:p-6 ml-0 max-w-2xl">
                  <p className="text-slate-700 text-sm sm:text-lg leading-relaxed">「医者と付き合える女って、どうせ若くて、可愛くて、スペック高い人でしょ」</p>
                </div>
                <div className="bg-rose-50 rounded-3xl p-4 sm:p-6 ml-auto max-w-xl">
                  <p className="text-slate-700 text-sm sm:text-lg leading-relaxed">「私には無理」</p>
                </div>
                <div className="bg-rose-50 rounded-3xl p-4 sm:p-6 ml-0 max-w-lg">
                  <p className="text-slate-700 text-sm sm:text-lg leading-relaxed">「今さら恋愛なんて」</p>
                </div>
              </div>
            </div>
            
            <div className="text-center pt-8 sm:pt-12 border-t-4 border-teal-400">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-slate-900 leading-tight">
                その思い込みが、<br />一番の敵だ。
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* ③ 著者の体験談 */}
      <section className="py-16 sm:py-32 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <i className="ri-stethoscope-line absolute top-20 right-20 text-teal-400" style={{ fontSize: '300px' }}></i>
          <i className="ri-heart-pulse-line absolute bottom-20 left-20 text-teal-400" style={{ fontSize: '250px' }}></i>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16">
            <div className="space-y-4 sm:space-y-6">
              <h3 className="text-lg sm:text-2xl text-teal-400 font-bold mb-6 sm:mb-8">著者のスペック（交際開始時）</h3>
              {[
                '無職（双極性障害で休職中）',
                'バツイチ（離婚直後・離婚1ヶ月28日後に交際開始）',
                '精神疾患持ち',
                'マチアプ歴ほぼゼロ',
                '恋愛ブランク10年'
              ].map((item, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border-l-4 border-teal-400 hover:bg-white/15 transition-all">
                  <p className="text-white text-sm sm:text-lg">{item}</p>
                </div>
              ))}
            </div>
            
            <div className="flex flex-col justify-center space-y-6 sm:space-y-8">
              <div className="bg-teal-400/10 backdrop-blur-sm rounded-3xl p-6 sm:p-10 border-2 border-teal-400">
                <p className="text-teal-400 text-xl sm:text-3xl lg:text-4xl font-black leading-relaxed">
                  → それで、某病院院長（43歳）と付き合っている。
                </p>
              </div>
              
              <div className="space-y-4 sm:space-y-6">
                <p className="text-white text-xl sm:text-3xl font-bold leading-relaxed">
                  秘密はシンプルだ。
                </p>
                <p className="text-white text-lg sm:text-2xl leading-relaxed">
                  <span className="bg-yellow-400 text-slate-900 px-3 py-1 rounded-lg font-bold">「医者マチアプ市場のルール」</span>を知ったこと。
                </p>
                <p className="text-white text-lg sm:text-2xl leading-relaxed">
                  それだけだ。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ④ 教材内容 */}
      <section id="contents" className="py-16 sm:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12 sm:mb-20">
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-6">この教材に詰まっているのは、<br />こういうことだ。</h2>
            <div className="w-80 h-1 bg-teal-400 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="md:col-span-2 lg:col-span-2 bg-gradient-to-br from-teal-50 to-teal-100 rounded-[30px] sm:rounded-[40px] p-8 sm:p-10 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-400 rounded-full flex items-center justify-center mb-5 sm:mb-6">
                <i className="ri-check-line text-white text-2xl sm:text-3xl"></i>
              </div>
              <p className="text-slate-900 text-lg sm:text-2xl leading-relaxed font-medium">
                医者がなぜマチアプにいるのか、本当の理由
              </p>
            </div>
            
            {[
              '勤務医・開業医・院長、それぞれが「求めているもの」の違い',
              '偽医者を3つの質問で一発で見抜く方法',
              '「選ばれよう」とせず「選ぶ女」に立つための思考法',
              '相手を好きにさせる会話術'
            ].map((text, index) => (
              <div key={index} className="bg-white rounded-[30px] sm:rounded-[40px] p-8 sm:p-10 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all border-2 border-slate-100">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-400 rounded-full flex items-center justify-center mb-5 sm:mb-6">
                  <i className="ri-check-line text-white text-2xl sm:text-3xl"></i>
                </div>
                <p className="text-slate-900 text-base sm:text-xl leading-relaxed font-medium">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ⑤ 対象読者 */}
      <section className="py-16 sm:py-32 bg-gradient-to-br from-rose-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 items-center">
            <div>
              <h2 className="text-2xl sm:text-4xl font-black text-slate-900 mb-8 sm:mb-12">こんな人に読んでほしい</h2>
              <div className="space-y-5 sm:space-y-8">
                {[
                  'バツイチだから、もう無理だと思っている人',
                  '精神疾患・障害があって、恋愛に自信が持てない人',
                  '医者と付き合いたいけど「どうせ私じゃ…」と思っている人',
                  'ハイスペ婚活ブログを読んで、逆に自信をなくした人',
                  'マチアプを始めたいけど、何から手をつければいいか全然わからない人'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3 sm:gap-4">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-heart-fill text-rose-400 text-xl sm:text-2xl"></i>
                    </div>
                    <p className="text-slate-700 text-base sm:text-xl leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-rose-200/30 to-purple-200/30 rounded-[40px] sm:rounded-[60px] transform rotate-3"></div>
              <div className="relative rounded-[40px] sm:rounded-[60px] overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=warm%20and%20hopeful%20silhouette%20of%20confident%20woman%20standing%20with%20arms%20crossed%2C%20soft%20pink%20and%20purple%20gradient%20background%2C%20empowering%20and%20uplifting%20atmosphere%2C%20gentle%20lighting%2C%20abstract%20feminine%20illustration%20style%2C%20modern%20minimalist%20design%2C%20inspirational%20mood%2C%20soft%20focus%20aesthetic&width=800&height=1000&seq=target001&orientation=portrait"
                  alt="対象読者イメージ"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-rose-300/40 via-transparent to-purple-300/40"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ⑥ 逆張り訴求 */}
      <section className="py-16 sm:py-32 bg-gradient-to-br from-purple-950 via-slate-900 to-purple-950 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)'
        }}></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <div className="border-4 border-yellow-400 rounded-[40px] sm:rounded-[60px] bg-black/60 backdrop-blur-sm p-8 sm:p-16 relative">
            <div className="absolute -top-5 -left-5 w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <i className="ri-alert-line text-slate-900 text-xl sm:text-2xl"></i>
            </div>
            <div className="absolute -top-5 -right-5 w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <i className="ri-alert-line text-slate-900 text-xl sm:text-2xl"></i>
            </div>
            <div className="absolute -bottom-5 -left-5 w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <i className="ri-alert-line text-slate-900 text-xl sm:text-2xl"></i>
            </div>
            <div className="absolute -bottom-5 -right-5 w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <i className="ri-alert-line text-slate-900 text-xl sm:text-2xl"></i>
            </div>
            
            <h2 className="text-2xl sm:text-4xl font-black text-yellow-400 mb-8 sm:mb-12 text-center">向いていない方</h2>
            
            <div className="space-y-6 sm:space-y-8">
              {[
                { text: '「医者ならだれでもいい」人', sub: '（職業目当てがバレた瞬間、終わる）' },
                { text: '奇麗事の「自分磨き論」が聞きたい人', sub: '（そういう本ではない）' },
                { text: '読むだけで行動しない人', sub: '（この教材は、使ってなんぼだ）' }
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 sm:gap-4">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-close-line text-red-500 text-3xl sm:text-4xl font-bold"></i>
                  </div>
                  <div>
                    <p className="text-white text-lg sm:text-2xl leading-relaxed font-medium">{item.text}</p>
                    <p className="text-slate-400 text-sm sm:text-lg mt-1 sm:mt-2">{item.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ⑦ ベネフィット */}
      <section className="py-16 sm:py-32 bg-gradient-to-b from-white via-teal-50 to-teal-100">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12 sm:mb-20">
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-black text-slate-900 leading-tight mb-6 sm:mb-8">
              読み終わった後、あなたは<br />「選ばれようとする女」をやめる。
            </h2>
            <div className="w-1 h-16 sm:h-24 bg-teal-400 mx-auto"></div>
          </div>
          
          <div className="space-y-10 sm:space-y-16">
            {[
              { title: 'マチアプを開いたとき', body: 'スワイプする手が変わる。', align: 'start' },
              { title: 'デートのとき', body: '相手を「観察する目」が生まれる。', align: 'end' },
              { title: '「私なんて…」という呪い', body: '少し溶ける。', align: 'start' }
            ].map((item, index) => (
              <div key={index} className="flex" style={{ justifyContent: item.align === 'end' ? 'flex-end' : 'flex-start' }}>
                <div className="bg-white rounded-[40px] sm:rounded-[50px] shadow-2xl p-8 sm:p-10 max-w-xl w-full sm:w-auto">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-400 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                    <i className="ri-check-line text-white text-xl sm:text-2xl"></i>
                  </div>
                  <h3 className="text-xl sm:text-3xl font-bold text-slate-900 mb-3 sm:mb-4">{item.title}</h3>
                  <p className="text-slate-600 text-base sm:text-xl leading-relaxed">{item.body}</p>
                </div>
              </div>
            ))}
            
            <div className="bg-slate-900 rounded-[40px] sm:rounded-[50px] shadow-2xl p-8 sm:p-12 text-center mt-12 sm:mt-20">
              <p className="text-teal-400 text-xl sm:text-3xl lg:text-4xl font-black leading-relaxed">
                「無職バツイチ障害者でも、医者彼氏ができた」は、再現できる。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ⑧ 著者プロフィール */}
      <section id="author" className="py-16 sm:py-32 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 sm:gap-16 items-center">
            <div className="lg:col-span-2 flex justify-center">
              <div className="relative">
                <div className="w-48 h-48 sm:w-72 sm:h-72 rounded-full overflow-hidden border-8 border-teal-400 shadow-2xl">
                  <img 
                    src="https://static.readdy.ai/image/d4208e7c1b6fcc1a247dec5c1658bdd1/3350539873bef847c7a83202d31ea058.jpeg"
                    alt="著者"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-teal-400 text-slate-900 px-6 py-2 rounded-full font-bold text-sm whitespace-nowrap">
                  著者
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-3 border-l-4 border-teal-400 pl-6 sm:pl-8">
              <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-6 sm:mb-8">大山あいりす</h2>
              <p className="text-slate-700 text-base sm:text-xl leading-loose">
                別名義でライター・エッセイスト活動を展開。<span className="text-teal-600 font-bold">32歳</span>で<span className="text-teal-600 font-bold">バツイチ</span>・<span className="text-teal-600 font-bold">双極性障害</span>・<span className="text-teal-600 font-bold">無職</span>の状態からマチアプを始め、<span className="text-teal-600 font-bold">2025年7月</span>、某病院院長の医師（43歳）と交際開始。「スペックで戦わない、医者マチアプ攻略法」を自らの実体験をもとに体系化した。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ⑨ 購入CTA */}
      <section id="purchase" className="py-16 sm:py-32 bg-gradient-to-br from-slate-900 via-black to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-10">
          <p className="text-teal-400 text-[150px] sm:text-[300px] font-black">START</p>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-tight mb-6 sm:mb-8">
            あなたが思っている以上に、<br />ゲームは開かれている。
          </h2>
          
          <p className="text-slate-300 text-base sm:text-2xl leading-loose mb-4 sm:mb-6">
            「私みたいな人間が」という呪いは、誰かがかけたものじゃない。自分でかけたものだ。
          </p>
          <p className="text-slate-300 text-base sm:text-2xl leading-loose mb-10 sm:mb-16">
            この教材は、その呪いを解くための地図だ。
          </p>
          
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-[40px] sm:rounded-[60px] p-8 sm:p-12 border-2 border-teal-400/30">
            <div className="space-y-6 sm:space-y-8">
              <div className="space-y-2">
                <p className="text-slate-500 text-base sm:text-lg line-through">通常価格 5,500円</p>
                <p className="text-yellow-400 text-2xl sm:text-4xl font-black">モニター価格 3,980円</p>
              </div>
              
              <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
                ※ このサイトはポートフォリオ用です。実際の「無職バツイチ障害者の私が医者彼氏と付き合えた秘密の方法」の販売はAmazonで行っています。
              </p>
              
              <button 
                className="group w-full max-w-2xl mx-auto bg-teal-400 text-slate-900 px-8 sm:px-16 py-4 sm:py-6 rounded-full text-xl sm:text-3xl font-black hover:bg-teal-300 transition-all shadow-2xl hover:shadow-teal-400/50 hover:scale-105 flex items-center justify-center gap-3 sm:gap-4 whitespace-nowrap cursor-pointer"
              >
                今すぐ手に入れる
                <i className="ri-arrow-right-line text-2xl sm:text-4xl group-hover:translate-x-2 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ⑩ FAQ */}
      <section id="faq" className="py-16 sm:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl sm:text-5xl font-black text-slate-900 text-center mb-10 sm:mb-16">よくある質問</h2>
          
          <div className="space-y-4 sm:space-y-6">
            {[
              {
                q: '医者と付き合う気はないけど、マチアプ全般に使えますか？',
                a: '使える。「選ぶ女になる」という根っこの考え方は、医者以外にも全部通じる。'
              },
              {
                q: '精神疾患・障害があっても本当に大丈夫ですか？',
                a: '著者自身がそのスペックで付き合っている。'
              },
              {
                q: 'マチアプ経験ゼロでも読めますか？',
                a: 'むしろゼロの方がいい。変な先入観がない分、そのまま実践に移しやすい。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl sm:rounded-3xl shadow-lg overflow-hidden border-2 border-slate-100">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-5 sm:px-8 py-4 sm:py-6 flex items-center justify-between hover:bg-slate-50 transition-colors cursor-pointer"
                >
                  <div className="flex items-center gap-3 sm:gap-4 flex-1 text-left">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-black text-base sm:text-xl">Q</span>
                    </div>
                    <p className="text-slate-900 text-sm sm:text-xl font-bold">{faq.q}</p>
                  </div>
                  <i className={`ri-arrow-down-s-line text-2xl sm:text-3xl text-slate-400 transition-transform flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                
                {openFaq === index && (
                  <div className="px-5 sm:px-8 pb-5 sm:pb-6 bg-teal-50/50">
                    <div className="flex items-start gap-3 sm:gap-4 pt-3 sm:pt-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-slate-900 font-black text-base sm:text-xl">A</span>
                      </div>
                      <p className="text-slate-700 text-sm sm:text-lg leading-relaxed pt-2">{faq.a}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-slate-900 py-10">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="flex flex-wrap items-center justify-center gap-6 mb-6">
            <a href="/tokushoho" className="text-slate-400 hover:text-teal-400 text-sm transition-colors whitespace-nowrap cursor-pointer">特定商取引法に基づく表記</a>
            <span className="text-slate-700 text-sm">|</span>
            <a href="/terms" className="text-slate-400 hover:text-teal-400 text-sm transition-colors whitespace-nowrap cursor-pointer">利用規約</a>
            <span className="text-slate-700 text-sm">|</span>
            <a href="/privacy" className="text-slate-400 hover:text-teal-400 text-sm transition-colors whitespace-nowrap cursor-pointer">プライバシーポリシー</a>
          </div>
          <p className="text-slate-500 text-sm">© 2025 大山あいりす All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}